export default __webpack_public_path__ + "static/media/cr.98bdf1a2.jpg";